import i18n from "@/i18n";
import { get, post } from "@/requests/server";

export async function addTrustedBorrower(libraryId, userId) {
  await post(
    `/libraries/${libraryId}/roles`,
    {
      user_id: userId,
      role: "trusted_borrower",
    },
    {
      notifications: {
        action: i18n.t(
          "requests.loanable_user_roles_requests.notifications.add_trusted_borrower.action"
        ),
        onSuccess: i18n.t(
          "requests.loanable_user_roles_requests.notifications.add_trusted_borrower.success"
        ),
      },
    }
  );
}

export async function searchUsersAssignableToRole(libraryId, role, q, params = {}) {
  const { data } = await get(`/libraries/${libraryId}/usersAssignableToRole`, {
    axiosRequestConfig: {
      params: {
        ...params,
        role,
        q,
      },
    },
    notifications: { action: i18n.t("store.rest_module.notifications.search.action") },
  });

  return data;
}
